import React from 'react';
export function ShareIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M7.669 8.243L6.331 6.757 12 1.655l5.669 5.102-1.338 1.486-3.544-3.19L13 17h-2l.213-11.947-3.544 3.19z"
  }), React.createElement("path", {
    d: "M2 10h6v2H4v8h16v-8h-4v-2h6v12H2V10z"
  }));
}